import { ACCOUNT_STATUS, PROFILE_VIEW_SETTINGS } from '../constants/constants';

export interface IApiAccountSettingsProfile {
  AccountPaused?: boolean;
  AccountRequiresAuthentication?: boolean;
  AccountStatus?: string;
  AccountDeletedDate?: string;
  ProfileViewSettings?: string;
  AnonymousBrowsing?: boolean;
  NewPasswordRequired?: boolean;
  ProfileViewable?: boolean;
  ReceiveEmailMessages?: boolean;
  ShowOnline?: boolean;
  PromoteProfile?: boolean;
  FeatureProfile?: boolean;
  ValidationViewSetting?: string;
  IntimateInfoViewSettings?: string;
  ProfileActivityViewSettings?: string;
  GCLID?: string;
}

export default class AccountSettingsProfile {
  accountPaused: boolean;
  accountRequiresAuthentication: boolean;
  profileViewSettings: string;
  anonymousBrowsing: boolean;
  newPasswordRequired: boolean;
  profileViewable: boolean;
  receiveEmailMessages: boolean;
  promoteProfile: boolean;
  showOnline: boolean;
  featureProfile: boolean;
  validationViewSetting: string;
  intimateInfoViewSetting: string;
  profileActivityViewSettings: string;
  accountStatus: string;
  accountDeleteDate: string;
  gclid: string;

  constructor() {
    this.accountPaused = false;
    this.accountRequiresAuthentication = false;
    this.profileViewSettings = '';
    this.anonymousBrowsing = false;
    // this.emailNotificationSettings = false;
    this.newPasswordRequired = false;
    this.profileViewable = false;
    this.receiveEmailMessages = false;
    this.promoteProfile = false;
    this.showOnline = false;
    this.featureProfile = false;
    this.validationViewSetting = '';
    this.intimateInfoViewSetting = '';
    this.profileActivityViewSettings = '';
    this.accountStatus = '';
    this.accountDeleteDate = '';
    this.gclid = '';
  }

  static mappingObject(_obj: IApiAccountSettingsProfile): AccountSettingsProfile {
    const obj = new AccountSettingsProfile();
    obj.accountPaused = _obj.AccountPaused || false;
    obj.accountRequiresAuthentication = _obj.AccountRequiresAuthentication || false;
    obj.accountStatus = _obj.AccountStatus || ACCOUNT_STATUS.ACTIVE;
    obj.accountDeleteDate = _obj.AccountDeletedDate || '';
    obj.profileViewSettings = _obj.ProfileViewSettings || PROFILE_VIEW_SETTINGS.NO_ONE;
    obj.anonymousBrowsing = _obj.AnonymousBrowsing || false;
    // obj.emailNotificationSettings = _obj.EmailNotificationSettings || false;
    obj.newPasswordRequired = _obj.NewPasswordRequired || false;
    obj.profileViewable = _obj.ProfileViewable || false;
    obj.receiveEmailMessages = _obj.ReceiveEmailMessages || false;
    obj.showOnline = _obj.ShowOnline || false;
    obj.promoteProfile = _obj.PromoteProfile || false;
    obj.featureProfile = _obj.FeatureProfile || false;
    obj.validationViewSetting = _obj.ValidationViewSetting || PROFILE_VIEW_SETTINGS.EVERYONE;
    obj.intimateInfoViewSetting = _obj.IntimateInfoViewSettings || PROFILE_VIEW_SETTINGS.EVERYONE;
    obj.profileActivityViewSettings = _obj.ProfileActivityViewSettings || PROFILE_VIEW_SETTINGS.EVERYONE;
    obj.gclid = _obj.GCLID || '';
    return obj;
  }
}
